import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CampaignFolderInterface } from 'app/models/campaign.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { CampaignFolderDataTransformPost } from './data-transforms/campaignfolder.data.transform.post';
import { CampaignFolderDataTransformGet } from './data-transforms/campaignfolder.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class CampaignFolderHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/campaignfolders(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformDown: CampaignFolderDataTransformPost,
    private readonly _transformUp: CampaignFolderDataTransformGet,
  ) {}

  intercept(
    req: HttpRequest<CampaignFolderInterface>,
    next: HttpHandler,
  ): Observable<HttpEvent<CampaignFolderInterface>> {
    return RequestService.getTransformedHttpEvent<CampaignFolderInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
